/**
 * Logo — inline SVG mark matching public/favicon.svg, kept in TSX so
 * the theme can influence its gradient colors.
 */

export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="logo-g" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#627eea" />
          <stop offset="1" stopColor="#a864fd" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill="url(#logo-g)" />
      <path
        d="M8 16 L14 10 L14 13 L20 13 L20 10 L26 16 L20 22 L20 19 L14 19 L14 22 Z"
        fill="white"
      />
    </svg>
  );
}
